import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../css/custom-datatable.css";
import "../css/Dashboard.css";
import { DashboardSalesPanel } from "../components/DashboardSalesPanel";
import { DashboardStorePanel } from "../components/DashboardStorePanel";
import { DashboardPatientPanel } from "../components/DashboardPatientPanel";

export default function Dashboard({
  show,
  openCashPopup,
  createPopupQuestion,
  removePopupQuestion,
}) {
  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data">
      <div className="patient-data-header">
        <span className="header-text">Dashboard</span>
      </div>
      <div
        className="patient-data-content dashboard-content"
        style={{ paddingBottom: 20 }}
      >
        <div className="action-bar">
          <div className="action-bar-resume">
            <span className="signed-text">Dashboard</span>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          {/* Panel de ventas */}
          <div className="dashboard-content">
            <DashboardSalesPanel
              openCashPopup={(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              ) =>
                openCashPopup(
                  selectedOpticId,
                  type,
                  show,
                  startDate,
                  endDate,
                  seeMore,
                  opticName,
                  agentId,
                )
              }
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
            />
          </div>
          {/* Panel de almacén */}
          <div className="dashboard-content">
            <DashboardStorePanel
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              openCashPopup={(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              ) =>
                openCashPopup(
                  selectedOpticId,
                  type,
                  show,
                  startDate,
                  endDate,
                  seeMore,
                  opticName,
                  agentId,
                )
              }
            />
          </div>
          {/* Panel de pacientes */}
          <div className="dashboard-content">
            <DashboardPatientPanel
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              openCashPopup={(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              ) =>
                openCashPopup(
                  selectedOpticId,
                  type,
                  show,
                  startDate,
                  endDate,
                  seeMore,
                  opticName,
                  agentId,
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
